import type { ReactNode } from 'react'
import { Search } from 'lucide-react'

export interface FilterBarProps {
  search?: string
  onSearch?: (value: string) => void
  searchPlaceholder?: string
  children?: ReactNode
  trailing?: ReactNode
}

export default function FilterBar({
  search,
  onSearch,
  searchPlaceholder = 'Suchen…',
  children,
  trailing,
}: FilterBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {onSearch && (
        <div className="relative flex-1 min-w-[220px] max-w-sm">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--muted-foreground)]" />
          <input
            type="text"
            value={search ?? ''}
            placeholder={searchPlaceholder}
            onChange={(e) => onSearch(e.target.value)}
            className="h-9 w-full rounded-md border border-[var(--border)] bg-[var(--background)] pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-[var(--ring)]"
          />
        </div>
      )}
      {children}
      {trailing && <div className="ml-auto flex items-center gap-2">{trailing}</div>}
    </div>
  )
}
